import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HackathonProvider } from "./contexts/HackathonContext";
import { AppShell } from "./components/layout/AppShell";
import { Home } from "./pages/Home";
import { Dashboard } from "./pages/Dashboard";
import { Groups } from "./pages/Groups";
import { GroupDetail } from "./pages/GroupDetail";
import { People } from "./pages/People";
import { PersonProfile } from "./pages/PersonProfile";
import { Program } from "./pages/Program";
import { DemoDay } from "./pages/DemoDay";
import { SubjectDraw } from "./pages/SubjectDraw";
import { TeamDraw } from "./pages/TeamDraw";
import { JoinProfile } from "./pages/public/JoinProfile";
import { CheckIn } from "./pages/public/CheckIn";
export function App() {
  return <HackathonProvider data-id="element-0" data-mp="28u5ysp4wd9dw">
      <BrowserRouter data-id="element-1" data-mp="28te21azkd5m1">
        <Routes data-id="element-2" data-mp="28suveqfd63nb">
          <Route path="/join/:token" element={<JoinProfile data-id="element-4" data-mp="23vuokdaowwv5" />} data-id="element-3" data-mp="28sb9kymlev40" />
          <Route path="/checkin/:token" element={<CheckIn data-id="element-6" data-mp="23ti8y6semyl9" />} data-id="element-5" data-mp="23ujkecdc1n3i" />
          <Route path="/organizer" element={<AppShell data-id="element-8" data-mp="3ij652c0mxp8x" />} data-id="element-7" data-mp="3ik7ekc2063oj">
            <Route index element={<Dashboard data-id="element-10" data-mp="3ii4ppvcl6gle" />} data-id="element-9" data-mp="3ijpdn24eb1aa" />
            <Route path="groups" element={<Groups data-id="element-12" data-mp="3mk83wrqn3zad" />} data-id="element-11" data-mp="3ml17jjuay8oa" />
            <Route path="groups/:id" element={<GroupDetail data-id="element-14" data-mp="3rbr9en3irte8" />} data-id="element-13" data-mp="3mjg93j4va5l5" />
            <Route path="people" element={<People data-id="element-16" data-mp="3recdzjv7cnfo" />} data-id="element-15" data-mp="3rdkisa5iorpx" />
            <Route path="people/:id" element={<PersonProfile data-id="element-18" data-mp="4wupmfw6qeo" />} data-id="element-17" data-mp="5ygolyg4xb6" />
            <Route path="program" element={<Program data-id="element-20" data-mp="2zl3cxocsjc6w" />} data-id="element-19" data-mp="56lhc8rh1lf" />
            <Route path="demo-day" element={<DemoDay data-id="element-22" data-mp="2zmo7vf30ox5a" />} data-id="element-21" data-mp="2zlv8x0aavbxp" />
            <Route path="draw/subjects" element={<SubjectDraw data-id="element-24" data-mp="33lwywc6oagx5" />} data-id="element-23" data-mp="2zng2amkvootz" />
            <Route path="draw/teams" element={<TeamDraw data-id="element-26" data-mp="33oi0d0326uud" />} data-id="element-25" data-mp="33n6xr3lcnt4u" />
          </Route>
          <Route path="*" element={<Home data-id="element-28" data-mp="38kgl8dp6huq1" />} data-id="element-27" data-mp="38kqbm2e4y3w9" />
        </Routes>
      </BrowserRouter>
    </HackathonProvider>;
}